module.exports = __webpack_public_path__ + "static/media/medicine2.c118148b.jpg";